export const HOME_DELIVERY = 'Despacho a domicilio'

export const PICKUP_POINT = 'Retiro en Punto'
export const PICKUP_POINT_LABEL = 'Retiro en Sucursal'

export const LOCAL_PICKUP = 'Retiro en Tienda'

export const PINFLAG_HOME_DELIVERY = 'homeDelivery'

export const PINFLAG_STORE_PICKUP = 'storePickup'

export const PINFLAG_CLICK_AND_COLLECT = 'clickAndCollect'
